import { CargaProps } from '../interfaces/carga-props';

export const useSettlementDownload = (props: CargaProps) => {
  const download = async (item: any) => {
    if (!item?.liqins_path) return;

    try {
      props.changeBlockUI?.(true);

      const response = await props.system.getSettlementSystem().downloadFile(item.liqins_id);

      window.open(response.link, '_blank');
    } catch (error) {
      props.courier.messageError(error);
    } finally {
      props.changeBlockUI?.(false);
    }
  };

  return { download };
};
